import { useContext } from 'react';
import { FlagContext } from '../FlagContext';
import { getEnabledFlagList } from '../helpers';
import { useDeepEqualMemo } from '../../hooks/useDeepEqualMemo';
export function useEnabledFlagList() {
    const flags = useContext(FlagContext);
    const flagList = useDeepEqualMemo(getEnabledFlagList(flags));
    return flagList;
}

//# sourceMappingURL=useEnabledFlagList.js.map